import type { NewsItem, NewsListRequest, NewsListResponse } from "@/types/news.types";
import { apiGet, apiPost } from "./client";

const DEFAULT_PAGE_SIZE = 12;

export async function getNewsList(params: {
  page: number;
  pageSize?: number;
  search?: string;
}): Promise<{ total: number; rows: NewsItem[] }> {
  const payload: NewsListRequest = {
    page: params.page,
    pageSize: params.pageSize ?? DEFAULT_PAGE_SIZE,
    search: params.search ?? "",
    sortBy: "publishDate",
    orderType: "desc",
  };
  const res = await apiPost<NewsListResponse>("/MiniApp/GetNewsList", payload);
  return {
    total: res.total ?? 0,
    rows: res.rows ?? [],
  };
}

export async function getNewsDetail(id: number): Promise<NewsItem> {
  return apiGet<NewsItem>(`/MiniApp/GetNewsDetail/${id}`);
}
